import { useMediaQuery } from '@mui/material'
import { PureLightTheme } from '../../../styles/theme'
import { MobileCard } from './Mobile'
import { DesktopCard } from './Desktop'
import { IProjectsListItem } from '../../../api/types'

interface ProjectItemProps {
  project: IProjectsListItem
}

export const ProjectItem = ({ project }: ProjectItemProps) => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down("sm"));

  return isMobile ? <MobileCard project={project} /> : <DesktopCard project={project} />;
}
